<template>
    <div class="search-form" :class="activeClass">
        <span class="close-button" @click="toggle()"><i class="fa fa-times"></i></span>
        <form class="input-group" @submit.prevent="submit()">
            <input
                type="text"
                name="keyword"
                placeholder="Search the site"
                class="input-group-field"
                v-model="keyword"
            >
            <div class="input-group-button">
                <button type="submit" class="button"><i class="fa fa-search"></i></button>
            </div>
        </form>
    </div>
</template>
<script>
    export default {
        props: {
            phrase: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                keyword: this.phrase,
                visible: false
            }
        },
        computed: {
            activeClass() {
                return {
                    active: this.visible
                }
            }
        },
        mounted() {
            window.EventHandler.listen('toggle-search', () => {
                this.toggle();
            });
        },
        methods: {
            toggle() {
                this.visible = !this.visible;
            },
            submit() {
                window.axios.post('/search-submit', {
                        keyword: this.keyword
                    })
                    .then(this.success)
                    .catch(this.failure);
            },
            success(response) {
                window.location.href = response.data.redirect;
            },
            failure(error) {
                throw new Error(error);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/src/components/Search/SearchForm.vue